<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="more-horizontal">
<g id="Vector">
<path d="M6.73324 11.9999C6.73324 12.9204 5.98704 13.6666 5.06657 13.6666C4.14609 13.6666 3.3999 12.9204 3.3999 11.9999C3.3999 11.0794 4.14609 10.3333 5.06657 10.3333C5.98704 10.3333 6.73324 11.0794 6.73324 11.9999Z" fill="#212328"/>
<path d="M21.3999 11.9999C21.3999 12.9204 20.6537 13.6666 19.7332 13.6666C18.8128 13.6666 18.0666 12.9204 18.0666 11.9999C18.0666 11.0794 18.8128 10.3333 19.7332 10.3333C20.6537 10.3333 21.3999 11.0794 21.3999 11.9999Z" fill="#212328"/>
<path d="M12.3999 13.6666C13.3204 13.6666 14.0666 12.9204 14.0666 11.9999C14.0666 11.0794 13.3204 10.3333 12.3999 10.3333C11.4794 10.3333 10.7332 11.0794 10.7332 11.9999C10.7332 12.9204 11.4794 13.6666 12.3999 13.6666Z" fill="#212328"/>
</g>
</g>
</svg>
